import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const CssTextField = withStyles({
  root: {
    '& label': {
      fontSize: vh(2.34),
    },
    '& label.Mui-focused': {
      color: themeColor.defaultTextColor,
    },
    '& label.Mui-focused.Mui-error': {
      color: themeColor.alert,
    },

    '& .MuiOutlinedInput-root': {
      width: '37.48vw',
      height: '8.33vh',
      fontSize: vh(2.34),
      backgroundColor: themeColor.white,
      '& fieldset': {
        borderColor: themeColor.secondaryLight,
      },
      '&.Mui-focused fieldset': {
        borderColor: themeColor.primaryDark,
      },
    },

    '& .MuiOutlinedInput-root.Mui-error': {
      '&.Mui-focused fieldset': {
        borderColor: themeColor.alert,
      },
    },

    '& p.MuiFormHelperText-root': {
      fontSize: vh(1.755),
      color: themeColor.defaultTextColor,
    },
    '& label.MuiFormLabel-root.Mui-error': {
      color: themeColor.alert,
    },
    '& p.MuiFormHelperText-root.Mui-error': {
      color: themeColor.alert,
    },
  },
})(TextField);
